var QueryString = require('./QueryString');

module.exports = {
    getOAuthToken: function () {
        var hash = document.location.hash.substr(1);
        var params = QueryString.parse(hash);

        if (typeof params.access_token != "undefined") {
            return params;
        }

        return null;
    }
};



// WEBPACK FOOTER //
// ./app/util/OAuth.js